export default __webpack_public_path__ + "static/media/330_private03-it-web.63cd4093.png";